import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Box, LinearProgress } from '@material-ui/core';
import NavBar from './NavBar';
import AuthGuard from 'src/components/AuthGuard';

const drawerWidth = 256;

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: drawerWidth
    }
  }
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = state => {
    if (!state) setOpenDrawer(!openDrawer);
  };

  return (
    <AuthGuard roles={['SUPERADMIN', 'ADMIN']}>
      <NavBar
        toggleDrawer={state => toggleDrawer(state)}
        openDrawer={openDrawer}
        drawerWidth={drawerWidth}
      />
      <Box className={classes.root}>
        <Suspense fallback={<LinearProgress />}>
          {renderRoutes(route.routes)}
        </Suspense>
      </Box>
    </AuthGuard>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
